import { Button } from "@/components/ui/button"

const ServiceDiscontinuation = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-fembot-pink/10 dark:from-transparent dark:to-fembot-pink/10">
        <div className="container-custom max-w-2xl mx-auto text-center px-4">
          <h2 className="text-3xl md:text-4xl font-extrabold text-fembot-pink mb-4 tracking-tight">
        Fembot Service Discontinuation
          </h2>
          <p className="text-lg md:text-xl text-gray-700 dark:text-gray-200 mb-6">
        The Fembot Discord bot will be discontinued on <span className="font-semibold">June 22, 2025</span>.<br />
        It will no longer be available after that date. Learn what this means for you and your community.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
          variant="outline"
          className="border-fembot-pink text-fembot-pink hover:bg-fembot-pink hover:text-white px-8 py-3 text-base font-semibold rounded-lg shadow transition"
          onClick={() => window.location.href = "/info"}
        >
          Learn more
        </Button>
          </div>
        </div>
      </section>
  )
}

export default ServiceDiscontinuation
